import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'
import FiltersBooleanBody from './filtersBooleanBody'

const FiltersBoolean = ({ name, label, location, history, isAtBottom, count, icon }) => {
  const parsedLocation = parseLocation(location)
  const isChecked = !!parsedLocation[name]

  const onChange = (event) => {
    const checkedValue = event.target.checked
    let newQuery = Object.assign({}, parsedLocation)
    delete newQuery.page

    if (checkedValue) {
      newQuery[name] = 1
    } else {
      delete newQuery[name]
    }

    history.push(makeLink(newQuery))
  }

  return (
    <FiltersBooleanBody
      name={name}
      label={label}
      onChange={onChange}
      isChecked={isChecked}
      isAtBottom={isAtBottom}
      count={count}
      icon={icon} />
  )
}

FiltersBoolean.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  icon: PropTypes.string,
  isAtBottom: PropTypes.bool,
  count: PropTypes.number
}

export const FiltersBooleanComponent = FiltersBoolean
export default withRouter(FiltersBoolean)



// WEBPACK FOOTER //
// ./client/components/filters/filtersBoolean.js